import * as React from "react";
import {cx} from "emotion";

import "./address-lists.scss";

import {cs}                      from "@Common/react/chain-services";
import {UseState}                from "@Common/react/use-state";
import {DataTableD1}             from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {InformationBadge}        from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {PageList}                from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize, PAGE_SIZE_ALL} from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {SearchInput}             from "@Common/ui-components/heavy/common/design2/search-input/search-input";
import {plural}                  from "@Common/ui-components/language/plural";
import {SliderCheckbox}          from "@Common/ui-components/slider-checkbox/slider-checkbox";

import {ErrorMessages} from "./error-messages/error-messages";

export const AddressLists = (
    {
        errorMessages,
        translateError=undefined,
        renderExtraOptions=undefined,

        totalQuantity, minQuantity,
        showErrors, mailingTable, getExtraRows,className,
    }
) => (
    <div className={cx("address-lists-5rp", className)}>
        <div className="actions">
            <button
                xd-qa-type="button"
                xd-qa-name="Create Address Lists"
                onClick={() => mailingTable.showCreateMailingListModal()}
            >
                Create Address Lists
            </button>
        </div>

        {ErrorMessages({
            disabled: !showErrors,
            translateError,
            ...errorMessages,
        })}

        <div className="list">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Selected Lists for this Order">
                    Selected lists for this order{" "}
                    {InformationBadge({
                        getTooltip: () => (
                            <div className="tooltip-5sx">
                                Select who you want to receive your mailers. Choose from the lists you have stored with Xpressdocs, upload your own list or create a new targeted mailing list.
                            </div>
                        ),
                        xdQaName: "Use My Default Card tooltip"
                    })}
                </div>
                <div className="sub-title" xd-qa-type="label" xd-qa-name="Selected Lists Description">
                    Lists to address your order with.
                </div>
            </div>

            <div className="controls">
                <div className="left">

                    <div className="selected-only">
                        <div className="label" xd-qa-type="label" xd-qa-name="Show Selected Only">
                            Show Selected Only
                        </div>
                        <div className="checkbox">
                            {SliderCheckbox({
                                ...mailingTable.selectedOnly,
                                xdQaName: "Show Selected Only",
                            })}
                        </div>
                    </div>

                    {renderExtraOptions?.()}
                </div>

                <div className="search">
                    {SearchInput({
                        state: mailingTable.filter,
                        placeholder: "Search Mailing List",
                        text: mailingTable.filter.value && <>Found <b>{mailingTable.rows.length}</b> {plural("mailing list", mailingTable.rows.length)}</>,
                        xdQaName: "Search Mailing List"
                    })}
                </div>
            </div>

            {cs(
                ["pageSize", (_, next) => UseState({next, getInitValue: () => 10})],
                ({pageSize}) => DataTableD1({
                    getDefaultSorting: () => ({
                        columnIndex: 4,
                        direction: "desc",
                    }),
                    className: cx("table", mailingTable.className),
                    paginationKey: mailingTable.selectedOnly.value,
                    columns: mailingTable.columns,
                    rows: mailingTable.rows,
                    emptyAction: mailingTable.emptyAction,
                    pageSize: pageSize.value,
                    getExtraRows: ({pagination, colCount}) => [
                        ...mailingTable.rows.length <= 10 ? [] : [{
                            className: "paging-control",
                            color: "light",
                            columns: [{
                                colSpan: colCount,
                                render: () => (
                                    <div className="controls">
                                        {PageSize({
                                            state: pageSize, 
                                            extraSizes: [PAGE_SIZE_ALL],
                                        })}

                                        {pagination.active && (
                                            <div className="pagination">
                                                {PageList(pagination)}
                                            </div>
                                        )}
                                    </div>
                                ),
                            }],
                        }],
                        ...getExtraRows?.({colCount})??[],
                    ],
                    getFooter: () => ({
                        columns: [
                            {},
                            {
                                colSpan: 2,
                                className: "summary",
                                render: () => <>
                                    <div className="title" xd-qa-type="label" xd-qa-name="Total Quantity">
                                        Total Quantity
                                    </div>
                                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Total Quantity Description">
                                        Order requires a minimum quantity of at least {minQuantity??"--"} items
                                    </div>
                                </>,
                            },
                            {
                                className: "count",
                                domAttrs: {
                                    "xd-qa-type": "label",
                                    "xd-qa-name": "Total Quantity Amount",
                                },
                                render: () => totalQuantity ?? "--",
                            },
                        ],
                    }),
                }),
            )}
        </div>
    </div>
);
